import type { FC, ReactNode } from 'react'

import { SplitText } from '@/components/motion/split-text'
import { Reveal } from '@/components/motion/reveal'
import { ArrowLink } from '@/components/site/arrow-link'
import { Portrait } from '@/components/site/portrait'
import { personalStatement } from '@/constants/home'

export const HomeAbout: FC = (): ReactNode => {
    return (
        <section
            id='about'
            className='relative z-[2] flex w-full flex-col items-center overflow-clip bg-background px-4 py-section-lg lg:px-6'
        >
            <div className='flex w-full flex-col md:flex-row md:items-start md:justify-center md:gap-6'>
                <div className='flex w-full flex-col py-6 pr-6 md:max-w-[32%] md:flex-1 md:self-stretch'>
                    <h2 className='t-label max-w-[400px] text-left text-foreground'>
                        Hello, I&apos;m Zaki
                    </h2>
                </div>

                <div className='flex w-full flex-col py-6 pr-6 md:flex-1'>
                    <SplitText
                        as='p'
                        text={personalStatement}
                        effect='rise'
                        by='word'
                        stagger={0.008}
                        amount={0.3}
                        className='t-statement w-full max-w-full text-left text-foreground [text-wrap:balance] md:max-w-[90%]'
                    />
                </div>
            </div>

            <div className='flex w-full flex-col md:flex-row md:items-end md:justify-center md:gap-6'>
                <div className='order-1 w-full py-6 md:order-none md:max-w-[32%] md:flex-1 md:pr-6'>
                    <Reveal y={16}>
                        <Portrait className='w-full max-w-[300px]' />
                    </Reveal>
                </div>

                <div className='order-none flex w-full items-center justify-start p-6 md:flex-1 md:py-6 md:pl-0 md:pr-6'>
                    <ArrowLink href='/about' label="More about me" />
                </div>
            </div>
        </section>
    )
}
